import React, { useContext, useState } from 'react';
import { AppContext } from './App';
import './AddInvites.css';
import axios from 'axios';
import { SERVER_URL } from './config';
import * as XLSX from 'xlsx';

const AddInvites = () => {
    const [invites, setInvites] = useState([{ name: '', phone: '', relation: 'אחר'}]);
    const { user } = useContext(AppContext);

    const phoneRegex = /^(?:05\d{8}|(?:\+|00)?9725\d{8})$/;

    const canPickContacts = !!(navigator.contacts && navigator.contacts.select);

    const importContacts = async () => {
        if (!canPickContacts) {
          alert("ייבוא אנשי קשר מהמכשיר נתמך רק ב-Chrome באנדרואיד.");
          return;
        }
        try {
            const contacts = await navigator.contacts.select(['name','tel'], { multiple: true });
            const formatted = contacts.map(c => {
                let phoneRaw = c.tel?.[0] || '';
                phoneRaw = phoneRaw.replace(/^(\+|00)/, '').replace(/\D/g, '');
                if (phoneRaw.startsWith('972')) {
                    phoneRaw = '0' + phoneRaw.slice(3);
                  }
                  if (phoneRaw.length === 9) {
                    phoneRaw = '0' + phoneRaw;
                  }
                  return {
                    name:     c.name?.[0] || '',
                    phone:    phoneRaw,
                    relation: 'אחר'
                  };
                });
                setInvites(prev => [...prev, ...formatted]);
            } catch (err) {
              console.error('Error picking contacts:', err);
            }
          };                                                        
    

    const isFormValid = () => {
        return invites.every(invite => invite.name && invite.phone && invite.relation);
    };
    
    const isPhoneValid = () => {
        const invalid = invites
          .filter(inv => !phoneRegex.test(inv.phone))
          .map(inv => inv.name || '(ללא שם)');
      
        return {
          valid: invalid.length === 0,
          invalidNames: invalid
        };
      };
    

    const handleSubmit = async () => {

        if (!isFormValid()) {
            alert("נא למלא את כל התאים");
            return;
        }
    
        const { valid, invalidNames } = isPhoneValid();
    if (!valid) {
        alert(
            `מספרי הטלפון הבאים לא תקינים:\n` +
            `הפורמט צריך להיות 05XXXXXXXX (10 ספרות) או 9725XXXXXXXX (12 ספרות),\n` +
            `או עם +9725XXXXXXXX:\n` +
            invalidNames.join(', ')
          );
      
      return; 
    }

    const normalizedInvites = invites.map(inv => {
        let phone = inv.phone;
        phone = phone.replace(/^(\+|00)/, '');

        if (phone.startsWith("972")) {
          phone = "0" + phone.slice(3);
        }
        return { ...inv, phone };
      });

      setInvites(normalizedInvites);
    
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${SERVER_URL}add_invites`,
                { invites: normalizedInvites },
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );
    
            const { status: serverStatus, failed_invites, successful_count } = response.data;
    
            if (serverStatus === 'success') {
                setInvites([{ name: '', phone: '', relation: '' }]);
            } else if (serverStatus === 'partial_success') {
                setInvites(failed_invites);
                const failedNames = failed_invites.map(i => i.name).join(', ');
                alert(`יש מוזמנים עם אותו שם ולכן הם לא נוספו: ${failedNames}\nנא לשנות את שמם ולנסות שוב`);
            }
    
        } catch (error) {
            console.error('Error adding invite:', error);
            alert("הייתה שגיאה בלתי צפויה. נא לנסות שוב");
        }
    };
    
    const handleInputChange = (index, field, value) => {
        if (field === "phone") {
            // Ensure only numbers and limit to 10 digits
            value = value.replace(/\D/g, "").slice(0, 10);
        }
    
        const updatedInvites = [...invites];
        updatedInvites[index][field] = value;
        setInvites(updatedInvites);
    };
    

    const addRow = () => {
      setInvites([...invites, { name: '', phone: '', relation: 'אחר' }]);
  };

  const removeRow = (index) => {
      setInvites(invites.filter((_, i) => i !== index));
  };

  const openPopup = () => {
      const rows = prompt('כמה שורות ברצונך להוסיף');
      if (rows && !isNaN(rows) && Number(rows) > 0) {
          const newRows = Array.from({ length: Number(rows) }, () => ({
              name: '',
              phone: '',
              relation: 'אחר',
          }));
          setInvites([...invites, ...newRows]);
      }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsBinaryString(file);

    reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Ensure all values are treated as text
        const jsonData = XLSX.utils.sheet_to_json(sheet, { raw: false });

        const formattedData = jsonData.map(row => {
            let phone = row['מספר טלפון'] ? row['מספר טלפון'].toString().replace(/\D/g, '') : '';

            // If phone has exactly 9 digits, add a leading zero
            if (phone.length === 9) {
                phone = "0" + phone;
            }

            return {
                name: row['שם'] || '',
                phone: phone, // Updated phone with the fix
                relation: row['סוג קשר'] || 'אחר',
            };
        });

        setInvites([...invites, ...formattedData]);
    };

    reader.onerror = (error) => {
        console.error("Error reading file:", error);
    };
};



  return (
    <div className="invite-form">
        <div className="import-contacts-section">
        <button
  type="button"
  className="import-contacts-button"
  onClick={importContacts}
>
  ייבא אנשי קשר מהמכשיר
</button>

<p className="import-note">
  הערה: ייבוא אנשי קשר מהמכשיר נתמך רק ב-Chrome באנדרואיד (אי אפשר להשתמש מהמחשב או מאייפון).  
</p>
</div>

                <div className="instructions">
                <p>📌 להעלאת אורחים באמצעות קובץ אקסל לחצו כאן:</p>
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload}
                    className="file-upload"
                />
                <p className="note">
                    ⚠️ שימו לב, ניתן להעלות קובץ אחד בכל הוספת אורחים.<br />
                    אם ברצונכם להעלות יותר מאחד, לחצו <b>'שמירה'</b> ולאחר מכן תעלו את הקובץ הבא.<br />
                    📌 יש לוודא ששמות ראשי העמודות באקסל הם: שם, מספר טלפון, סוג קשר
                </p>
            </div>

            {user?.general_invite_slug && (
  <div className="general-link-section">
    <p className="general-link-description">
      📎 ניתן לשתף את הקישור הבא בקבוצות (למשל WhatsApp) כדי לאפשר לאורחים להירשם בעצמם:
    </p>
    <div className="general-link-box">
  <input
    type="text"
    readOnly
    value={`https://mariage-il.com/invitation/general/${user.general_invite_slug}`}
    onClick={(e) => e.target.select()}
    className="general-link-input"
  />
  <button
    className="copy-link-button"
    onClick={() => {
      navigator.clipboard.writeText(`https://mariage-il.com/invitation/general/${user.general_invite_slug}`);
      alert("הקישור הועתק ללוח!");
    }}
  >
    העתק קישור
  </button>
  <a
    className="whatsapp-share-button"
    href={`https://wa.me/?text=${encodeURIComponent(
      "💌 היי! הנה הקישור להרשמה לחתונה שלנו: " +
      `https://mariage-il.com/invitation/general/${user.general_invite_slug}`
    )}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    שיתוף ב־WhatsApp
  </a>
</div>
  </div>
)}  

        <table className="invite-form-table">
            <thead>
                <tr>
                    <th>שם</th>
                    <th>מספר טלפון</th>
                    <th>סוג קשר</th>
                    <th>פעולות</th>
                </tr>
            </thead>
            <tbody>
                {invites.map((invite, index) => (
                    <tr key={index}>
                        <td>
                            <input
                                type="text"
                                placeholder="הכנס שם"
                                value={invite.name}
                                onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                            />
                        </td>
                        <td>
                        <input
    type="text" 
    placeholder="הכנס מספר טלפון"
    value={invite.phone}
    onChange={(e) => handleInputChange(index, "phone", e.target.value)}
    onKeyDown={(e) => {
        // Allow control keys: Backspace, Tab, Enter, Arrow keys, Delete
        if (
            ["Backspace", "Tab", "Enter", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
        ) {
            return;
        }
        
        // Block non-numeric characters
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    }}
/>

                        </td>
                        <td>
                            <select
                                value={invite.relation}
                                onChange={(e) => handleInputChange(index, 'relation', e.target.value)}
                            >
                                <option value="">בחר סוג קשר</option>
                                <option value="חברים חתן">חברים חתן</option>
                                <option value="חברים כלה">חברים כלה</option>
                                <option value="חברים הורים">חברים הורים</option>
                                <option value="משפחה חתן">משפחה חתן</option>
                                <option value="משפחה כלה">משפחה כלה</option>
                                <option value="אחר">אחר</option>
                            </select>
                        </td>
                        <td>
                            <button className="remove-row-button" onClick={() => removeRow(index)}>
                                הסר
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <div className="button-row">
            <button className="add-row-button" onClick={addRow}>
                הוסף שורה
            </button>
            <button className="add-multiple-rows-button" onClick={openPopup}>
                הוסף מספר שורות
            </button>
            <button className="submit-button" onClick={handleSubmit}>
                שמירה
            </button>
        </div>
    </div>
);
};

export default AddInvites;